import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";


export const getItemRequestNo = (async (docsClassificationId) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi.ItemRequest.nextRequestNo,
    method: 'get',
    params : {
        docsClassificationId:docsClassificationId
    }
})
    .then((response) => (response.data))

)